import React, { useState } from "react";
import {
  Button,
  Col,
  Modal,
  Row,
  ListGroup,
  ProgressBar,
  Form,
  ListGroupItem,
  Accordion,
} from "react-bootstrap";
const Case4 = ({
  handleBack3,
  activeKey,
  setActiveKey,
  Handleform4,
  handleChange,
  Specification,
  uploadPrescriptionHandler,
}) => {
  const [pdType, setPdType] = useState("");
  const [validationErrors, setValidationErrors] = useState({});

  const handleAccordionSelect = (key) => {
    setActiveKey(key);
    setValidationErrors({});

    // Reset form values when switching between manual and upload
    if (key === "upload") {
      // Set all manual form values to 0
      handleChange("od_sph", 0);
      handleChange("od_cyl", 0);
      handleChange("od_axis", 0);
      handleChange("os_sph", 0);
      handleChange("os_cyl", 0);
      handleChange("os_axis", 0);
      handleChange("pd_type", "None");
      handleChange("pd_value", 0);
      if (Specification.prescriptionType === "Progressive") {
        handleChange("Add_Power", 0);
      }
    }
  };

  // Handle PD type change
  const handlePdTypeChange = (value) => {
    setPdType(value);
    handleChange("pd_type", value);
    if (value === "None") {
      handleChange("pd_value", 0);
    }
    setValidationErrors({ ...validationErrors, pdType: "" });
  };

  const validateForm = (e) => {
    const errors = {};
    if (activeKey === "manual") {
      if (!pdType) {
        errors.pdType = "Please select a PD type";
      }
    }
    if (Object.keys(errors).length > 0) {
      e.preventDefault();
      setValidationErrors(errors);
      return;
    }

    Handleform4(e);
  };

  return (
    <>
      <Col
        className='shadow'
        md={8}
        style={{ display: "flex", flexDirection: "column", height: "100vh" }}
      >
        <ProgressBar
          className=' Fpro shadow'
          variant='info'
          animated
          now={75}
        />

        <Modal.Header closeButton>
          <Button
            onClick={handleBack3}
            size='sm'
            className='btn-light Psbutton shadow'
          >
            <i className='fa fa-arrow-left' aria-hidden='true'></i>
          </Button>
        </Modal.Header>

        <Modal.Title className='text-center mb-3'>
          Help Us With Your Details
        </Modal.Title>

        <Modal.Body
          className='flex-grow-1'
          style={{ overflowY: "auto", paddingBottom: "20px" }}
        >
          <Accordion activeKey={activeKey} onSelect={handleAccordionSelect}>
            <Accordion.Item
              eventKey='manual'
              style={{ border: "1px solid silver" }}
            >
              <Accordion.Header>Enter Prescription Manually</Accordion.Header>
              <Accordion.Body>
                <Form onSubmit={validateForm}>
                  <ListGroup variant='flush'>
                    <ListGroupItem>
                      <Form.Label as='legend'>OD (Right Eye)</Form.Label>
                      <Row>
                        <Form.Group as={Col} xs='4'>
                          SPH
                          <Form.Select
                            required={activeKey === "manual"}
                            disabled={activeKey === "upload"}
                            size='sm'
                            as='select'
                            onChange={(e) =>
                              handleChange("od_sph", e.target.value)
                            }
                          >
                            <option value='' hidden>
                              Select
                            </option>
                            {[...Array(40)].map((_, i) => {
                              const value = -9.5 + i * 0.5;
                              return (
                                <option key={value} value={value}>
                                  {value.toFixed(1)}
                                </option>
                              );
                            })}
                          </Form.Select>
                        </Form.Group>
                        <Form.Group as={Col} xs='4'>
                          CYL{" "}
                          <Form.Select
                            size='sm'
                            as='select'
                            onChange={(e) =>
                              handleChange("od_cyl", e.target.value)
                            }
                            required={activeKey === "manual"}
                            disabled={activeKey === "upload"}
                          >
                            <option value='' hidden>
                              Select
                            </option>
                            {[...Array(40).keys()].map((x) => {
                              const value = -9.5 + x * 0.5; // Calculate the value

                              if (value % 1 === 0) {
                                return (
                                  <option key={value} value={value}>
                                    {value.toFixed(1)}
                                  </option>
                                );
                              } else {
                                return (
                                  <option key={value} value={value}>
                                    {value.toFixed(1)}
                                  </option>
                                );
                              }
                            })}
                          </Form.Select>
                        </Form.Group>
                        <Form.Group as={Col} xs='4'>
                          AXIS{" "}
                          <Form.Select
                            size='sm'
                            as='select'
                            onChange={(e) =>
                              handleChange("od_axis", e.target.value)
                            }
                            required={activeKey === "manual"}
                            disabled={activeKey === "upload"}
                          >
                            <option value='' hidden>
                              Select
                            </option>
                            {[...Array(36).keys()].map((x) => {
                              const value = 5 + x * 5;

                              return (
                                <option key={value} value={value}>
                                  {value}
                                </option>
                              );
                            })}
                          </Form.Select>
                        </Form.Group>
                      </Row>
                    </ListGroupItem>

                    <ListGroupItem>
                      <Form.Label as='legend'>OS (Left Eye)</Form.Label>
                      <Row>
                        <Form.Group as={Col} xs='4'>
                          SPH
                          <Form.Select
                            size='sm'
                            as='select'
                            onChange={(e) =>
                              handleChange("os_sph", e.target.value)
                            }
                            required={activeKey === "manual"}
                            disabled={activeKey === "upload"}
                          >
                            <option value='' hidden>
                              Select
                            </option>
                            {[...Array(40).keys()].map((x) => {
                              const value = -9.5 + x * 0.5; // Calculate the value

                              if (value % 1 === 0) {
                                return (
                                  <option key={value} value={value}>
                                    {value.toFixed(1)}
                                  </option>
                                );
                              } else {
                                return (
                                  <option key={value} value={value}>
                                    {value.toFixed(1)}
                                  </option>
                                );
                              }
                            })}
                          </Form.Select>
                        </Form.Group>
                        <Form.Group as={Col} xs='4'>
                          CYL{" "}
                          <Form.Select
                            size='sm'
                            as='select'
                            onChange={(e) =>
                              handleChange("os_cyl", e.target.value)
                            }
                            required={activeKey === "manual"}
                            disabled={activeKey === "upload"}
                          >
                            <option value='' hidden>
                              Select
                            </option>
                            {[...Array(40).keys()].map((x) => {
                              const value = -9.5 + x * 0.5; // Calculate the value

                              if (value % 1 === 0) {
                                return (
                                  <option key={value} value={value}>
                                    {value.toFixed(1)}
                                  </option>
                                );
                              } else {
                                return (
                                  <option key={value} value={value}>
                                    {value.toFixed(1)}
                                  </option>
                                );
                              }
                            })}
                          </Form.Select>
                        </Form.Group>
                        <Form.Group as={Col} xs='4'>
                          AXIS{" "}
                          <Form.Select
                            size='sm'
                            as='select'
                            onChange={(e) =>
                              handleChange("os_axis", e.target.value)
                            }
                            required={activeKey === "manual"}
                            disabled={activeKey === "upload"}
                          >
                            <option value='' hidden>
                              Select
                            </option>
                            {[...Array(36).keys()].map((x) => {
                              const value = 5 + x * 5;

                              return (
                                <option key={value} value={value}>
                                  {value}
                                </option>
                              );
                            })}
                          </Form.Select>
                        </Form.Group>
                      </Row>
                    </ListGroupItem>
                    {Specification.prescriptionType === "Progressive" && (
                      <ListGroupItem>
                        <Form.Label as='legend'>Add Power (+)</Form.Label>
                        <Row>
                          <Form.Group as={Col} xs='4'>
                            <Form.Select
                              size='sm'
                              as='select'
                              onChange={(e) =>
                                handleChange("Add_Power", e.target.value)
                              }
                              required={activeKey === "manual"}
                              disabled={activeKey === "upload"}
                            >
                              <option value='' hidden>
                                Select
                              </option>
                              {[
                                0.0, 0.25, 0.5, 0.75, 1.0, 1.25, 1.5, 1.75, 2.0,
                                2.25, 2.5, 2.75, 3.0,
                              ].map((value) => (
                                <option key={value} value={value.toFixed(2)}>
                                  {value.toFixed(2)}
                                </option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                        </Row>
                      </ListGroupItem>
                    )}

                    {/* PD Section */}
                    <ListGroupItem>
                      <Form.Label as='legend'>
                        Pupillary Distance (PD)
                      </Form.Label>
                      <Row>
                        <Form.Group as={Col} xs='6'>
                          <div
                            style={{
                              //   backgroundColor: "#d9d9d9",
                              //   marginBottom: "3px",
                              textAlign: "center",
                            }}
                            className='bg-light p-2 rounded'
                          >
                            <Form.Check
                              inline
                              label='Single PD'
                              value='Single'
                              name='pdGroup'
                              type='radio'
                              disabled={activeKey === "upload"}
                              onChange={(e) =>
                                handlePdTypeChange(e.target.value)
                              }
                            />
                            <Form.Check
                              inline
                              label='Dual PD'
                              value='Dual'
                              name='pdGroup'
                              type='radio'
                              disabled={activeKey === "upload"}
                              onChange={(e) =>
                                handlePdTypeChange(e.target.value)
                              }
                            />
                            <Form.Check
                              inline
                              label='None'
                              value='None'
                              name='pdGroup'
                              type='radio'
                              disabled={activeKey === "upload"}
                              onChange={(e) =>
                                handlePdTypeChange(e.target.value)
                              }
                            />
                          </div>
                          {validationErrors.pdType && (
                            <div className='text-danger small mt-1'>
                              {validationErrors.pdType}
                            </div>
                          )}
                        </Form.Group>
                        <Form.Group as={Col} xs='6'>
                          <Form.Select
                            required={
                              activeKey === "manual" && pdType !== "None"
                            }
                            size='sm'
                            disabled={
                              pdType === "None" || activeKey === "upload"
                            }
                            onChange={(e) =>
                              handleChange("pd_value", e.target.value)
                            }
                          >
                            <option value='' hidden>
                              Select PD (in cm)
                            </option>
                            {[...Array(21)].map((_, i) => {
                              const value = i * 5;
                              return (
                                <option key={value} value={value}>
                                  {value.toFixed(1)}
                                </option>
                              );
                            })}
                          </Form.Select>
                        </Form.Group>
                      </Row>
                    </ListGroupItem>

                    <ListGroupItem className='d-flex justify-content-center'>
                      <Button
                        className='Psbutton shadow btn-light rounded mt-3'
                        type='submit'
                      >
                        Save Changes and Continue
                      </Button>
                    </ListGroupItem>
                  </ListGroup>
                </Form>
              </Accordion.Body>
            </Accordion.Item>

            <div className='position-relative my-3'>
              <hr
                className='position-absolute w-100 top-50'
                style={{ margin: 0 }}
              />
              <div className='d-flex justify-content-center'>
                <span
                  className='bg-white px-3 text-muted'
                  style={{ position: "relative", zIndex: 1 }}
                >
                  OR
                </span>
              </div>
            </div>

            <Accordion.Item
              eventKey='upload'
              style={{ border: "1px solid silver" }}
            >
              <Accordion.Header>Upload Prescription Document</Accordion.Header>
              <Accordion.Body>
                <Form.Group>
                  <Form.Label>
                    Upload Your Prescription (Accepted formats: JPG, JPEG, PNG,
                    PDF)
                  </Form.Label>
                  <Form.Control
                    type='file'
                    id='uploadedPrescription'
                    accept='.jpg, .jpeg, .png, .pdf'
                    onChange={uploadPrescriptionHandler}
                    required={activeKey === "upload"}
                  />
                </Form.Group>
                <Button
                  className='Psbutton shadow btn-light rounded mt-3'
                  onClick={Handleform4}
                >
                  Save Changes and Continue
                </Button>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Modal.Body>
      </Col>
    </>
  );
};

export default Case4;
